import { createBrowserRouter, Navigate } from 'react-router-dom'
import App from './App'
import ProtectedRoute from '@/components/ProtectedRoute'
import {
  AddRecipesPage, CreateMixPage, GroceryListPage, InvitationPage, MixesPage, NotFoundPage,
  RecipePage, MixPage, ScheduleAddRecipePage, SignInPage, LandingPage, ForgotPasswordPage,
  UpdatePasswordPage,
} from '@/pages'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        index: true,
        element: <LandingPage />
      },
      {
        path: '/home',
        element: (
          <ProtectedRoute>
            <MixesPage />
          </ProtectedRoute>
        )
      },
      {
        path: '/mixes/:mixId',
        element: (
          <ProtectedRoute>
            <MixPage />
          </ProtectedRoute>
        )
      },
      {
        path: '/mixes/:mixId/add-recipes',
        element: (
          <ProtectedRoute>
            <AddRecipesPage />
          </ProtectedRoute>
        )
      },
      {
        path: '/mixes/:mixId/invitations/:invitationId',
        element: <InvitationPage />
      },
      {
        path: '/mixes/:mixId/recipes',
        element: (
          <ProtectedRoute>
            <MixPage />
          </ProtectedRoute>
        )
      },
      {
        path: '/mixes/:mixId/recipes/:recipeId',
        element: (
          <ProtectedRoute>
            <RecipePage />
          </ProtectedRoute>
        )
      },
      {
        path: '/mixes/:mixId/grocerylist',
        element: (
          <ProtectedRoute>
            <GroceryListPage />
          </ProtectedRoute>
        )
      },
      {
        path: '/signin',
        element: <SignInPage />
      },
      {
        path: '/mixes/new',
        element: (
          <ProtectedRoute>
            <CreateMixPage />
          </ProtectedRoute>
        )
      },
      {
        path: '/schedules/:scheduleId/add-recipe',
        element: (
          <ProtectedRoute>
            <ScheduleAddRecipePage />
          </ProtectedRoute>
        )
      },
      {
        path: '/forgot-password',
        element: <ForgotPasswordPage />
      },
      {
        path: '/update-password',
        element: <UpdatePasswordPage />
      },
      {
        path: 'not-found',
        element: <NotFoundPage />
      },
      {
        path: '*',
        element: <Navigate to="/not-found" replace />
      }
    ]
  }
])
